import React, { Component } from 'react';
import ReactDOM from 'react-dom';
// import Dash from '../../dashboardComponent/dashboard2';
// import { API_URL } from '../../../config';
// import swal from 'sweetalert';
// import Head from '../../header/header'
// import $ from 'jquery'
class Userprofile extends Component {

    constructor() {
        super();
        this.state = {

            
        }




    }
     
    componentDidMount(){  
        
         console.clear()   
    }
    OnSubmiClick()
    {
        
    }
    
    render() {


        return (


        <>
          
                <div class="content-overlay"></div>
                <div class="header-navbar-shadow"></div>
                <div class="content-wrapper">
                    <div class="content-header row">
                    </div>
                    <div class="content-body px-0">
                  
                        <section class="invoice-preview-wrapper">
                        
                            <div class="row invoice-preview">
                                <section class="app-user-edit col-9 pt-0">
                                    <div class="card px-2 pb-4">
                                        
                                        <div class="card-body">
                                        <div class="content-header row" style={{fontWeight:'bold',fontSize:'18px'}}>Profile</div>
                                            <ul class="nav nav-pills" role="tablist">
                                                <li class="nav-item">
                                                    <a class="nav-link d-flex align-items-center" id="information-tab" data-toggle="tab" href="#information" aria-controls="information" role="tab" aria-selected="false">

                                                    </a>
                                                </li>

                                            </ul>
                                            <div class="tab-content">

                                                <div class="tab-pane active" id="account" aria-labelledby="account-tab" role="tabpanel">
                                                     
                                                    <form class="form-validate">
                                                        <div class="row">
                                                        <div class="col-md-4">
                                                                <div class="form-group">
                                                                    <label for="username">Login Id</label>
                                                                    <input type="text" readOnly value={localStorage.getItem('empCode') }   class="form-control"  name="username" id="username" />
                                                                </div>
                                                            </div>
                                                            <div class="col-md-4">
                                                                <div class="form-group">
                                                                    <label for="username">Name</label>
                                                                    <input type="text"  readOnly value={localStorage.getItem('empName') }    class="form-control"  name="username" id="username" />
                                                                </div>
                                                            </div>
                                                          
                                                            <div class="col-md-4">
                                                                <div class="form-group">
                                                                    <label for="email">E-mail</label>
                                                                    <input type="email"readOnly value={localStorage.getItem('emailId')} class="form-control" name="email" id="email" />
                                                                </div>
                                                            </div>

                                                         
                                                            <div class="col-lg-4 col-md-6">
                                                                <div class="form-group">
                                                                    <label for="mobile">Mobile</label>
                                                                    <input  id="mobile" readOnly value={localStorage.getItem('phoneNo')} type="text" class="form-control" name="phone" />
                                                                </div>
                                                            </div> 
 


                                                        </div>
                                                    </form>
                                                    {localStorage.getItem("userType")!= "distributor"?
                                                    <form class="form-validate">
                                                        <div class="row mt-1">
                                                            <div class="col-12">
                                                                <h4 class="mb-1">
                                                                    
                                                                    <span class="align-middle">Personal Information</span>
                                                                </h4>
                                                            </div>
                                                           
                                                            <div class="col-lg-4 col-md-6">
                                                                <div class="form-group">
                                                                    <label for="fp-default">User Type</label>
                                                                    <input id="fp-default" readOnly  value={localStorage.getItem('userTypeOrg')} type="text" class="form-control birthdate-picker" name="dob" placeholder="01 Jan 2000" />
                                                                </div>
                                                            </div>
                                                          
                                                            <div class="col-lg-4 col-md-6">
                                                                <div class="form-group">
                                                                    <label for="address-1">Address</label>
                                                                    <input id="address-1"  readOnly value={localStorage.getItem('address')}  type="text" class="form-control" name="address" />
                                                                </div>
                                                            </div>

                                                            
                                                        </div>
                                                    </form>
                                                    :null}

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </section>



                                <div class="col-xl-3 col-md-4 col-12 invoice-actions mt-md-0 mt-2">


<div class="card mb-0" style={{display:"none"}}>
    <div class="card-body">
        <a type="submit" class="btn btn-outline-primary btn-block mb-75" data-toggle="modal" data-target="#modals-slide-in" >

            <span>Change Passwords</span>
        </a>
        <a  class="btn btn-primary btn-block mb-75" target="_blank" >

            <span onClick={this.OnSubmiClick}  >Save Changes</span>
        </a>

        {/* <a class="btn btn-secondary btn-block mb-75" target="_blank" >
            <i class="fas fa-angle-double-left mr-50"></i>
            <span>Back}</span>
        </a> */}

    </div>
</div>
</div>
                            </div>
                             <div class="modal modal-slide-in fade" id="modals-slide-in">
                                <div class="modal-dialog sidebar-sm">
                                    <form class="add-new-record modal-content pt-0">
                                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">×</button>
                                        <div class="modal-header mb-1">
                                            <h5 class="modal-title" id="exampleModalLabel">Changepassword</h5>
                                        </div>
                                        <div class="modal-body flex-grow-1">

                                            <div class="form-group">
                                                <label class="form-label" for="basic-icon-default-email">Old Password</label>
                                                <input type="password" id="oldp" class="form-control dt-email" placeholder="" />

                                            </div>

                                            <div class="form-group">
                                                <label class="form-label" for="basic-icon-default-email">New Password</label>
                                                <input type="password" id="newp" class="form-control dt-email" placeholder="" />

                                            </div>

                                            <div class="form-group">
                                                <label class="form-label" for="basic-icon-default-email">Retype new Password</label>
                                                <input type="password" id="cnewp" class="form-control dt-email" placeholder="" />

                                            </div>

                                            <button type="button" class="btn btn-primary data-submit mr-1 btn-page-block-overlay waves-effect " >Submit</button>
                                            <button type="reset" class="btn btn-outline-secondary" id='close' data-dismiss="modal">Cancel</button>
                                        </div>
                                    </form>
                                </div>
                            </div>

                        </section> 
                    </div>
                </div>
            </>






        );


    }
}
export default Userprofile